import React from 'react'
import "./AboutPage.css"

export const AboutPage = () => {
    return (
        <div className="AboutPageContainer">
         <h1 style={{textAlign: 'center'}}>Learn To Lead</h1>
         <h2>About Us</h2>
         <h4>Vision</h4>
         <p>To Create An Environment For Individuals To Realize Their Full Potential.</p>

         <h4>Mission</h4>
         <p>Sivakasi Nadars School Will Create Nurturing Ground Through It's Team To Help Individuals To
         Meet The Global Challenged And Lead In All Spheres</p>
{/*
         <div className="creditsContainer">

          <div className="correspondentImageContainer">
            <img width="300" className="correspondentImage" alt="correspondent-image" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/creditspic%2Fcorress.png?alt=media&token=0aab8958-c051-49bb-a3e1-7a70977109dc"/>
            <div>Thanks to our honourable Correspondent Mr.V.Rama Sundharasekharan for funding the app and providing his esteemed support</div>
          </div>

          <div style = {{ textAlign: 'right' }} className="principalImageContainer">
            <div>Thanks to our honourable principal Mrs.G.V.Kiruthika for her esteemed support and guidance</div>
            <img width="300" className="principalImage" alt="principal-image" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/creditspic%2FPrincipal.jpeg?alt=media&token=2ece29d8-ffec-4643-a026-4154f71fe197"/>
          </div>

          <div className="correspondentImageContainer">
            <img width="300" className="correspondentImage" alt="correspondent-image" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/creditspic%2FRMK.jpeg?alt=media&token=2cb02914-37cd-43ef-9e5a-46844983341d"/>
            <div>Thanks to our supportive teacher Mrs.J.Ramakrishnan for his insights and guidance</div>
          </div>
         </div>
*/}
        </div>
    )
}